import { SubcategoryDetailModel } from './subcategory.detail.model';

export class PagedSubcategoryDetailModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: SubcategoryDetailModel[] = [];
}
